<!--  -->
<template>
  <div class="upload-source-content">
    <gat-head />
    <div class="upload-nav">
      <!-- <div class="nav-inner">
        <el-button size="small" type="primary" @click="crateUpload">点击上传</el-button>
      </div> -->
      <div class="nav-inner-encrypt">
        <el-button 
          size="small" 
          type="primary" 
          @click="oneEncrypt"
        >点击加密转义</el-button>
        <div class="encrypt">
          <el-input v-model="inputText" @keyup.enter.native="oneEncrypt" placeholder="请输入转义内容" clearable></el-input>
          <p>{{ encryptText }}</p>
        </div>
      </div>
    </div>
      <!-- list of filesList-->
    <section class="upload-list-main">
      <div class="nav-inner">
        <el-button size="small" type="primary" @click="crateUpload">点击上传文件</el-button>
      </div>
      <el-table :data="filesList" stripe style="width:100%">
        <el-table-column prop="fileName" label="名称" width="400px">
          <template slot-scope="scope">
            <span :title="scope.row.name" class="t-name ellipsis">{{ scope.row.fileName }}</span>
            
          </template>
        </el-table-column>
        <el-table-column prop="url" label="上传地址"> </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <div class="pagination" v-if="filesList.length">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="pagination.pageNum"
          :page-size="pagination.pageSize"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="pagination.total"
        ></el-pagination>
      </div> -->
    </section>
  </div>
</template>

<script>
//上传文件等公共接口
import COMMON from '@/axios/common/common.js'
export default {
  name: 'uload-source',
  components: {},
  data() {
    return {
      inputText: '',
      encryptText: '',
      filesList: [
        {
          fileName:'',
          url:'',
        }
      ],
        pagination: {
        pageSize: 10,
        pageNum: 1,
        total: null,
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    if(sessionStorage.filesList){
      this.filesList =JSON.parse(sessionStorage.filesList)
    }
  },
  mounted() {},
  methods: {
    oneEncrypt() {
      if (this.inputText) {
        this.encryptText = this.$util.urlToStr.encrypt(this.inputText); // 加密方法
      } else {
        this.encryptText = '';
      }
      // this.$util.urlToStr.decrypt(); // 解密方法
    },
    crateUpload() {
      let self =this
      let inputNode = document.createElement('input'),
        reg_name = /[`~!@#$^&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('multiple', 'true')
      inputNode.onchange = function uploadImg(evt) {
        // 获取 file
        let fileList = evt.target.files,
          list = Array.from(fileList),
          formatPass,
          formdata = new FormData()

        list.forEach((file) => {
          formdata.append('file', file)
        })
        if (list.length > 20) {
          return self.$message({
            message: '单次上传不可超过20个文件哦！',
            type: 'error',
            duration: 2000,
          })
        }
        const loading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        COMMON.UploadMultipleFile(formdata).then(async (result) => {
          loading.close()
          if (result && result.returnCode == 200 && result.data) {
            self.$nextTick(()=>{
              self.filesList = result.data
              sessionStorage.filesList =JSON.stringify(result.data)
            })
            // console.log('filesList',self.filesList)
          }
        })
      }
      inputNode.click()
    },
        handleCurrentChange(pageIdx) {
      // this.pagination.pageNum = pageIdx
      // this.getRecycleList()
    },
    multiUpload() {},
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './Upload.scss';
</style>
